import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { Card, CardHeader, Stack, Text } from "@chakra-ui/react";

import { selectActiveProperties } from "../../../redux/user/userSlice";
import { getPropertyAddress } from "../../../utils/verifier";

import PropertyMessagesCard from "./PropertyMessagesCard";

export default function Messages() {
	const properties = useSelector(selectActiveProperties);
	const user = useSelector((state) => state.user?.user);
	const { t } = useTranslation();
	return (
		<Stack>
			<Card>
				<CardHeader>
					<Text fontSize="xl" fontWeight="bold">
						{t("navbarMenu.messages")}
					</Text>
				</CardHeader>
			</Card>
			{properties.map((property, index) => (
				<PropertyMessagesCard
					address={getPropertyAddress(property)}
					propertyId={property.id}
					messages={property.messages}
					name={user.name}
					email={user.email}
					key={index}
				/>
			))}
		</Stack>
	);
}
